/* eslint-disable @typescript-eslint/default-param-last */
import produce from 'immer';
import {
    SET_CURRENT_LENGTH_DETAIL,
    SET_CURRENT_SIZE_DETAIL,
    SET_CURRENT_AVAILABLE_LENGTHS,
} from '../../constants';
import { SizePickerState, SizePickerActionTypes } from '../types';

const initialState: SizePickerState = {
    currentEanLengths: undefined,
    currentLengthDetail: null,
    currentSizeDetail: null,
};

const sizePicker = produce((state: SizePickerState, action: SizePickerActionTypes) => {
    const { type, payload } = action;

    // eslint-disable-next-line default-case
    switch (type) {
        case SET_CURRENT_SIZE_DETAIL:
            state.currentSizeDetail = payload;
            break;

        case SET_CURRENT_LENGTH_DETAIL:
            state.currentLengthDetail = payload;
            break;

        case SET_CURRENT_AVAILABLE_LENGTHS:
            state.currentEanLengths = payload;
    }
}, initialState);

export default sizePicker;
